import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  id: "i2101200371__Ebene_1",
  viewBox: "0 0 192 192"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [
    _cache[1] || (_cache[1] = _createElementVNode("desc", null, "Reden", -1)),
    _createElementVNode("defs", null, [
      (_openBlock(), _createBlock(_resolveDynamicComponent("style"), null, {
        default: _withCtx(() => _cache[0] || (_cache[0] = [
          _createTextVNode(".i2101200371__cls-1{fill:none}.i2101200371__cls-2{fill:#2d2d2d}")
        ])),
        _: 1
      }))
    ]),
    _cache[2] || (_cache[2] = _createElementVNode("path", {
      d: "M172 71.09V36.91c0-.5-.41-.91-.91-.91h-62.18c-.5 0-.91.41-.91.91v34.18c0 .31.14.52.27.64.12.12.33.27.64.27H116c1.06 0 2.08.42 2.83 1.17S120 74.94 120 76v6.36l9.17-9.17c.75-.75 1.77-1.17 2.83-1.17h39.09c.5 0 .91-.41.91-.91Z",
      class: "i2101200371__cls-1"
    }, null, -1)),
    _cache[3] || (_cache[3] = _createElementVNode("circle", {
      cx: "60",
      cy: "92",
      r: "16",
      class: "i2101200371__cls-1"
    }, null, -1)),
    _cache[4] || (_cache[4] = _createElementVNode("path", {
      d: "M60 116c13.23 0 24-10.77 24-24S73.23 68 60 68 36 78.77 36 92s10.77 24 24 24m0-40c8.82 0 16 7.18 16 16s-7.18 16-16 16-16-7.18-16-16 7.18-16 16-16M15.85 181.07l11.59-40.96c1.35-4.77 5.83-8.11 10.89-8.11h43.36c5.07 0 9.55 3.34 10.89 8.11l11.57 40.97 7.7-2.17-11.56-40.97C97.98 129.73 90.33 124 81.7 124H38.33c-8.63 0-16.27 5.73-18.59 13.93L8.16 178.89l7.7 2.18ZM180 71.09V36.91c0-4.91-4-8.91-8.91-8.91h-62.18C104 28 100 32 100 36.91v34.18c0 2.38.93 4.62 2.61 6.3a8.86 8.86 0 0 0 6.3 2.61H112v12.01c0 1.62.97 3.08 2.47 3.7a4.031 4.031 0 0 0 4.36-.87l14.83-14.83h37.43c4.91 0 8.91-3.99 8.91-8.91ZM132 72c-1.06 0-2.08.42-2.83 1.17L120 82.34v-6.36c0-1.06-.42-2.08-1.17-2.83a4 4 0 0 0-2.83-1.17h-7.09c-.31 0-.52-.14-.64-.27a.9.9 0 0 1-.27-.64V36.91c0-.5.41-.91.91-.91h62.18c.5 0 .91.41.91.91v34.18c0 .5-.41.91-.91.91z",
      class: "i2101200371__cls-2"
    }, null, -1))
  ]))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "personTalk"}) } }